import { render } from "./PayTipsForm.vue?vue&type=template&id=f6d7afbc&lang=pug"
import script from "./PayTipsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PayTipsForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__